import type { PendingBasket } from "../types"
import { BasketItemRow } from "./BasketItemRow"
import { ContinueShoppingChips } from "./ContinueShoppingChips"
import styles from "../styles/widgetFin.module.css"

function fmtPrice(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`
}

export function BasketView({
  basket,
  onRemove,
  onQtyChange,
  onCheckout,
  onUserReply,
}: {
  basket: PendingBasket
  onRemove: (itemId: string) => void
  onQtyChange: (itemId: string, qty: number) => void
  onCheckout: () => void
  onUserReply: (text: string) => void
}) {
  if (basket.items.length === 0) {
    return (
      <div className={styles["basket-empty"]}>
        <div className={styles["basket-empty-title"]}>Your cart is empty</div>
        <div className={styles["basket-empty-sub"]}>Ask Pearl to build a kit or recommend a product.</div>
      </div>
    )
  }
  return (
    <div className={styles["basket-view"]}>
      {/* Customer-facing copy uses "cart" (matches Shopify storefront's
        * vocabulary). "Basket" was Pearl-side staging language but it
        * confused customers ("am I in a separate Pearl cart?") — caught
        * 2026-06-03. Internal tool names (add_to_basket, commit_basket)
        * + module names + CSS classes stay as "basket" since they're
        * server/code concepts only the team sees. */}
      <div className={styles["basket-view-label"]}>YOUR CART</div>
      <div className={styles["basket-view-list"]}>
        {basket.items.map((item) => (
          <BasketItemRow
            key={item.id}
            item={item}
            onRemove={onRemove}
            onQtyChange={onQtyChange}
          />
        ))}
      </div>
      <div className={styles["basket-view-footer"]}>
        <div className={styles["basket-view-subtotal"]}>
          <span>Subtotal</span>
          <span>{fmtPrice(basket.subtotal)}</span>
        </div>
        {/* Since 2026-06-10 every item shown here is ALREADY in the live
          * Shopify cart (adds mirror at add time — see useChatStream
          * "basket_update" side-effect). So this button reads "View cart"
          * and takes the customer to the real cart; the old "Add to cart"
          * label implied the items weren't in the cart yet, which was the
          * exact confusion that lost the joeplesher kit sales. */}
        <button
          type="button"
          className={styles["basket-view-checkout"]}
          onClick={onCheckout}
        >
          View cart — {fmtPrice(basket.subtotal)}
        </button>
        <ContinueShoppingChips
          onSelect={onUserReply}
          chips={[
            "Carry on shopping",
            "Add another color",
            "What else should I add?",
          ]}
        />
      </div>
    </div>
  )
}
